import { removeClass }      from "@TsUtils//helpers";
import type { InertiaForm } from "@inertiajs/vue3";
import { localeRoute }      from "@Plugins/localeRoute";

const submit = (e : Event, form : InertiaForm<any>, formEl : HTMLElement, route : string) : void => {
    if ((e.target as HTMLFormElement).checkValidity()) {
        form.post(
            localeRoute(route), {
                onSuccess: () => {
                    form.clearErrors();
                    removeClass('was-validated', formEl);
                    form.reset();
                }
            }
        );
    }
};

export { submit };
